import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Maintenance from "./pages/Maintenance";
import Home from "./pages/Home";
import Collection from "./pages/Collection";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Admin from "./pages/Admin";

/* --------------------------
   MAINTENANCE MODE TOGGLE
-------------------------- */

const MAINTENANCE_MODE = false; 
// true  = website shows maintenance page
// false = website runs normally

function App() {
  return (
    <div className="App">
      <BrowserRouter>

        {MAINTENANCE_MODE ? (
          <Routes>
            <Route path="*" element={<Maintenance />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/collection" element={<Collection />} />
            <Route path="/about" element={<About />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        )}

      </BrowserRouter>
    </div>
  );
}

export default App;